import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, GuestSharedTrustAccountDTO} from '@sollapay/types';

export const guestApi = {
  fetchAccounts: async (client: HttpClient): Promise<ApiResponse<GuestSharedTrustAccountDTO[]>> =>
    client.get<ApiResponse<GuestSharedTrustAccountDTO[]>>('/guest/trust-accounts')
};
